//
export default {
  defaultType: 0,
  TT107: 1,
};
